module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "修改头像"
    }
  }, [_c('management')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "密码设置"
    }
  }, [_c('password')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d3fa39c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personalData/index.vue
// module id = 261
// module chunks = 18